'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('./DropdownTrigger.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownTrigger = function (_BcReactComponent) {
  _inherits(DropdownTrigger, _BcReactComponent);

  function DropdownTrigger(props) {
    _classCallCheck(this, DropdownTrigger);

    var _this = _possibleConstructorReturn(this, (DropdownTrigger.__proto__ || Object.getPrototypeOf(DropdownTrigger)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(DropdownTrigger, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onClick();
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      var _props = this.props,
          describedById = _props.describedById,
          descriptionLocalizedText = _props.descriptionLocalizedText;

      if (descriptionLocalizedText) {
        return _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { id: describedById },
          descriptionLocalizedText
        );
      }
      return null;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _props2 = this.props,
          labelLocalizedText = _props2.labelLocalizedText,
          labelledById = _props2.labelledById;

      if (labelLocalizedText) {
        return _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { id: labelledById },
          labelLocalizedText
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          testId = _props3.testId,
          hasPopup = _props3.hasPopup,
          ButtonTag = _props3.ButtonTag,
          isLoading = _props3.isLoading,
          disabled = _props3.disabled,
          renderTrigger = _props3.renderTrigger;

      var btnClass = ButtonTag ? (0, _classnames2.default)('cp-dropdown-trigger', className) : (0, _classnames2.default)('cp-dropdown-trigger', 'btn', className, 'dropdown-toggle');

      var TagForButton = ButtonTag || _baseButtons.Button;

      var buttonChildren = [this.props.children, _react2.default.createElement(
        _baseScreenReaderMessage2.default,
        { key: 'shows-more-content' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_shows_more_content' })
      )];

      var propsForButton = {
        disabled: disabled,
        type: 'button',
        handleClick: this.handleClick,
        isLoading: isLoading,
        'aria-haspopup': hasPopup,
        'aria-expanded': this.props.expanded,
        className: btnClass,
        'data-test-id': testId,
        children: buttonChildren
      };

      if (renderTrigger) {
        return renderTrigger(propsForButton);
      }

      return _react2.default.createElement(TagForButton, propsForButton);
    }
  }]);

  return DropdownTrigger;
}(_baseBcReactComponent2.default);

DropdownTrigger.propTypes = {
  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
  className: _react.PropTypes.string.isRequired,
  labelledById: _react.PropTypes.string.isRequired,
  labelLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  descriptionLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  testId: _react.PropTypes.string,
  isLoading: _react.PropTypes.bool,
  hasPopup: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  renderTrigger: _react.PropTypes.func
};

exports.default = DropdownTrigger;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-trigger/components/DropdownTrigger.component.js
// module id = 1075
// module chunks = 1